'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.Widgets.Carousel', dependencies).directive('rmCarousel', require('./directives/CarouselDirective'));